/**
 * Search normalization utilities shared across the portal.
 *
 * `norm(s)` returns a lowercase, accent-stripped version of `s` so users can
 * type `pañal` and match `panal` (and vice versa), or `cafe` and match
 * `café`. Meant to be applied both to the query and to the fields you're
 * matching against.
 */
export const stripAccents = (s) =>
  String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const norm = (s) => stripAccents(s).toLowerCase();
